export default "__VITE_ASSET__HmBQ$k2a__"